'use client';

import React from 'react';

import { Banner } from '../Banner';

import { HeaderBannerProps } from './types';

const primaryButtonAnalyticsMeta = {
  componentName: 'headerBanner',
  title: 'primaryButton',
};

export const HeaderBanner: React.FC<HeaderBannerProps> = (props) => {
  return (
    <Banner
      backgroundGradient={props.backgroundGradient}
      button={props.button}
      buttonMeta={primaryButtonAnalyticsMeta}
      description={props.description}
      image={props.image}
      layout="twoColumns"
      showCompanies={props.showCompanies}
      size="hero"
      title={props.text}
    />
  );
};
